import React, { useEffect, useState } from 'react';

import { Form, Modal, Input, InputNumber } from 'antd';
import { NotificationInstance } from 'antd/es/notification/interface';

import { userLoaded } from '@store/actions';
import { useAppDispatch } from '@store/hooks';

import IBaseComponentProps from '@components/base-component-props';

import { exception } from '@extensions/notification';

import { IUserBalanceLine } from '@entities/user-balance-line';
import { UserBalanceDetailTypes } from '@enums/user-balance-detail-type';

interface IRubleBillParams {
    amount: number;
    comment?: string;
}

interface IRubleBillModalProps extends IBaseComponentProps {
    entity?: IUserBalanceLine;
    lineIds: Array<string>;
    api: NotificationInstance;
    onSave: () => void;
    onCancel: () => void;
}

const RubleBillModal = (props: IRubleBillModalProps) => {
    const { entity, lineIds, api, onSave, onCancel, serverFetch } = props;

    const { TextArea } = Input;

    const [form] = Form.useForm();

    const d = useAppDispatch();

    const [isEditMode, setIsEditMode] = useState<boolean>(false);

    useEffect(() => {
        if (entity) {
            setIsEditMode(!!entity.amountRub);

            form.setFieldValue('amount', entity.amountRub);
            form.setFieldValue('comment', entity.comment);
        }
    }, [entity]);

    const onSetRubAmount = (data: IRubleBillParams) => {
        const groupData = {
            groupId: entity?.groupId,
            lineIds: lineIds,
            amount: data.amount,
            comment: data.comment,
        };

        if (lineIds.length > 1 || (entity && entity.groupId)) {
            serverFetch('userbalances/groups', { method: isEditMode ? 'PUT' : 'POST', bodyData: groupData })
                .then(() => {
                    onSave();
                })
                .catch((ex: any) => {
                    exception(api, 'Ошибка сохранения суммы в рублях', ex, () => d(userLoaded(undefined)));
                });
        } else {
            serverFetch('userbalances/ruble', { method: 'POST', bodyData: groupData })
                .then(() => {
                    onSave();
                })
                .catch((ex: any) => {
                    exception(api, 'Ошибка сохранения суммы в рублях', ex, () => d(userLoaded(undefined)));
                });
        }
    };

    return (
        <Modal
            destroyOnHidden={true}
            width={550}
            title={isEditMode ? `Изменить сумму в рублях` : `Указать сумму в рублях`}
            open={true}
            okText='ОК'
            onOk={() => {
                form.submit();
            }}
            onCancel={() => onCancel()}
        >
            <Form
                colon={false}
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 18 }}
                style={{ marginTop: 20 }}
                form={form}
                onFinish={onSetRubAmount}
            >
                <Form.Item
                    label='Сумма'
                    name='amount'
                    wrapperCol={{ span: 9 }}
                    rules={[{ required: !isEditMode, message: 'Укажите сумму' }]}
                >
                    <InputNumber
                        precision={2}
                        decimalSeparator=','
                        min={0}
                        style={{ width: '100%' }}
                        onChange={(value: number | null) => {
                            form.setFieldValue('amount', value);
                        }}
                    />
                </Form.Item>

                <Form.Item label='Комментарий' name='comment'>
                    <TextArea rows={4} />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default RubleBillModal;
